module.exports = __webpack_public_path__ + "static/images/styles/images/nations/japan-cn.b2f4bd9d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/japan-cn.png
// module id = 3667
// module chunks = 11